import { IInitParams } from 'constants/types/search.types'
import { multiSelectKeys, Key } from 'constants/search-data/search-data'
import { IOptions, IAnyObj } from 'constants/types/common.types'

const checkKeyInObject = (obj: IAnyObj, key: string) => obj[key] && obj[key]?.length
const getCheckoxParams = (param: string) => param.split(',').filter((item) => item) as string[]
const getDateParams = (param: string) =>
  param
    .split(',')
    .map((date) => Number(date))
    .filter((item) => item)
    .reverse()

const getMultiSelectParams = (param: string, selectElements: any[]) =>
  param
    .split(',')
    .filter((item) => item)
    .map((item) => {
      const numberedItem = Number(item)
      if (!numberedItem || isNaN(numberedItem))
        return selectElements.find((category) => category.value === item)
      return selectElements.find((category) => category.value === numberedItem)
    })
    .filter((item) => item.value) as IOptions[]

const formatSelectForURL = (paramOptions: IOptions[]) => paramOptions.map((item) => item.value)
const formatDateForURL = (paramOptions: Date[]) =>
  paramOptions
    .filter((item) => item)
    .map((item) => new Date(item).getTime())
    .reverse()

const formatSelectForAnalytic = (paramOptions: IOptions[]) => paramOptions.map((item) => item.label)
const formatDateForAnalytic = (paramOptions: Date[]) =>
  paramOptions
    .filter((item) => item)
    .map((item) => {
      const date = new Date(item)
      return [date.getDate(), date.getMonth() + 1, date.getFullYear()].join('.')
    })

const getAnalyticParams = (currentParams: IInitParams) => {
  const analyticParams = Object.keys(currentParams).reduce((acc, key) => {
    let param

    if (multiSelectKeys.includes(key) && currentParams[key]?.length)
      param = formatSelectForAnalytic(currentParams[key] as IOptions[])
    else if (key === Key.DATES && currentParams[key]?.length) {
      param = formatDateForAnalytic(currentParams[key] as Date[])
    } else if (currentParams[key]?.length) param = currentParams[key]

    return param ? { ...acc, [key]: String(param) } : acc
  }, {})

  return analyticParams
}

export {
  checkKeyInObject,
  getCheckoxParams,
  getDateParams,
  getMultiSelectParams,
  formatSelectForURL,
  formatDateForURL,
  getAnalyticParams,
}
